// extracted by mini-css-extract-plugin
module.exports = {"groupLegend":"_1UEE8kMWgnMP4lQ7hG5nA3"};